import { HoopHouseIcon } from './HoopHouseIcon';

/**
 * author: Jeff Anders
 * id 088F07BD-BEA9-46D5-A2DF-0B9FA37BBF99
 * name hoop-house
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hoop-house.svg
 * tags
 * - Agriculture 
 * - Home Automation 
 */
export const HighTunnelIcon = HoopHouseIcon;
export default HighTunnelIcon